

























import { Component, Watch } from 'vue-property-decorator';
import ItemTable from '@/components/common/ItemTable.vue';
import RecurringPaymentsProductManagementMixin from '@/components/product/recurringPayments/recurringPaymentsProductManagement/RecurringPaymentsProductManagementMixin';
import { gridProps, GridProps, DEFAULT_SEARCH_QUERY_OBJECT } from '@/components/product/recurringPayments/recurringPaymentsProductManagement/SearchResultAssistant';
import {
  GetProductsRegularDeliveryRequest,
  ProductsRegularDeliveryContent,
  DeleteProductsRegularDeliveryRequest
} from 'supporter';
import { parse, stringify } from 'qs';
import {getMallsConfigurationsByKey, ncpPopup, convertProductUri} from '@/utils/commonUtils';
import cloneDeep from 'lodash.clonedeep';
import ClickEvent = JQuery.ClickEvent;

const PRODUCT_DETAIL_URL_MAP: {[key: string]: string} = {};

@Component({
  components: {
    ItemTable,
  }
})
export default class SearchResult extends RecurringPaymentsProductManagementMixin {
  private gridData: ProductsRegularDeliveryContent[] = [] as ProductsRegularDeliveryContent[];
  private gridProps: GridProps = gridProps();
  private queryObject: GetProductsRegularDeliveryRequest['params'] = {} as GetProductsRegularDeliveryRequest['params'];

  private mounted() {
    this.updateQueryObject();
    getMallsConfigurationsByKey(this, 'MALL_PRODUCT').then((data: { productDetailUrl: string, mallNo: number }[]) => {
      data.forEach(({ productDetailUrl, mallNo }) => PRODUCT_DETAIL_URL_MAP[mallNo] = productDetailUrl);
      $('body').on('click', '[name=recurringPaymentProductNoBtn]', this.handleRecurringPaymentProductNoBtnClick);
    });
  }

  private beforeDestroy() {
    $('body').off('click', '[name=recurringPaymentProductNoBtn]', this.handleRecurringPaymentProductNoBtnClick);
  }

  @Watch('queryObject')
  @Watch('gridProps.options.pageOptions.page')
  @Watch('gridProps.options.pageOptions.perPage')
  private async fetchGridData(): Promise<void> {
    const request: GetProductsRegularDeliveryRequest = {
      params: {
        ...this.queryObject,
        page: this.gridProps.options.pageOptions.page,
        size: this.gridProps.options.pageOptions.perPage,
      }
    };

    try {
      const response = await this.$api.getProductsRegularDelivery(request);
      this.gridData = response.data.contents;
      this.gridProps.options.pageOptions.totalCount = response.data.totalCount;
    } catch (e) {
      console.error(e);
    }
  }

  @Watch('$route.query')
  private updateQueryObject(): void {
    let newQueryObject;

    if (!Object.keys(this.$route.query).length) {
      newQueryObject = cloneDeep(DEFAULT_SEARCH_QUERY_OBJECT);
    }
    else {
      newQueryObject = parse(stringify(this.$route.query), { allowDots: true }) as unknown as GetProductsRegularDeliveryRequest['params'];
      delete newQueryObject['dataRefresh'];
    }

    if (newQueryObject.registerPeriod) {
      newQueryObject.registerPeriod.startYmdt += ' 00:00:00';
      newQueryObject.registerPeriod.endYmdt += ' 23:59:00';
    }

    this.queryObject = newQueryObject;
  }

  private handleRegisterProductBtnClick(): void {
    this.$router.push('/product/recurring-payment/register-prev');
  }

  private handleModifySettingBtnClick(): void {
    const checkedRows = (this.$refs.itemTable as ItemTable).gridFunction('getCheckedRows');

    if (!checkedRows.length) {
      alert(this.getI18nOfThis('PLEASE_SELECT_PRODUCT_TO_CHANGE_SETTING'))
      return;
    }

    const selectedProductsInfo = checkedRows.map(row => ({ mallNo: row.mallNo, productNo: row.productNo, salePrice: row.salePrice }));

    window.localStorage.setItem('selectedProductsInfo', JSON.stringify(selectedProductsInfo) );
    ncpPopup(
        '/product/recurring-payment/popup/change-opt',
        this.getI18nOfThis('CHANGING_RECURRING_PAYMENTS_PRODUCT_SETTING'),
        810,
        570,
    );
  }

  private handleDeleteBtnClick(): void {
    if (!confirm(this.getI18nOfThis('DELETE_PRODUCT_CONFIRM_TEXT'))) return;

    const checkedRows = (this.$refs.itemTable as ItemTable).gridFunction('getCheckedRows');
    if (!checkedRows.length) {
      alert(this.getI18nOfThis('PLEASE_SELECT_PRODUCT_TO_CHANGE_SETTING'))
      return;
    }

    const { productNosSet, mallNosSet }: { productNosSet: Set<number>, mallNosSet: Set<number> } = checkedRows.reduce((acc, currRow) => {
      const { productNo, mallNo } = currRow;
      acc.productNosSet.add(productNo);
      acc.mallNosSet.add(mallNo);
      return acc;
    }, { productNosSet: new Set(), mallNosSet: new Set() })

    const productNos: number[] = Array.from(productNosSet);
    const mallNos: number[] = Array.from(mallNosSet);

    this.deleteProductsRegularDelivery(productNos, mallNos)
        .then(() => {
          alert(this.$t('ALERT_DELETE_SUCCESS'));
          this.fetchGridData();
        })
        .catch((e) => { console.error(e) })
  }

  private async deleteProductsRegularDelivery(productNos: number[], mallNos: number[]): Promise<void> {
    const request: DeleteProductsRegularDeliveryRequest = {
      params: {
        productNos: productNos,
        mallNos: mallNos,
      }
    }

    try {
      await this.$api.deleteProductsRegularDelivery(request);
    } catch (e) {
      throw new Error(e);
    }
  }

  private setPageData(page: number = 1, size?: number) {
    if (size) {
      this.gridProps.options.pageSize = size.toString();
      this.gridProps.options.pageOptions.perPage = size;
    }
    this.gridProps.options.pageOptions.page = page;
  }

  private handleRecurringPaymentProductNoBtnClick(e: ClickEvent): void {
    e.preventDefault();
    const $btn = $(e.currentTarget);
    const mallNo = $btn.data('mall-no');
    const productNo = $btn.data('product-no');
    convertProductUri
    const redirectUrl = convertProductUri(PRODUCT_DETAIL_URL_MAP[mallNo], productNo);

    window.open(redirectUrl);
  }
}

